import { render } from "./Labs.vue?vue&type=template&id=7c715657"
import script from "./Labs.vue?vue&type=script&lang=js"
export * from "./Labs.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organisation/Partials/Labs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c715657"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c715657', __exports__)) {
    console.log('reload')
    api.reload('7c715657', __exports__)
  }
  
  module.hot.accept("./Labs.vue?vue&type=template&id=7c715657", () => {
    console.log('re-render')
    api.rerender('7c715657', render)
  })

}


export default __exports__